/**
 * Company: AltSolution
 */

"use strict";
const LANGUAGE = document.getElementsByTagName('html')[0].getAttribute('lang');

$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});

// let $carouselProductImage = $('.info-slider-slider:not(.no-init)');
// $imagesCarousel.on('changed.owl.carousel', function(event){
//     let currentItem = event.item.index;
//     $carouselMenu.find('.active').removeClass('active');
//     $carouselMenu.find('a:nth-child(' + (currentItem + 1) + ')').addClass('active');
// });

//Navigate
let $navProductSlider = $('.info-slider-nav');

$navProductSlider.find('.info-slider-prev').on('click', function () {
    let activeIndex = $navProductSlider.find('.info-slider-items a.active').index();
    if(activeIndex > 0) {
        $navProductSlider.find('.info-slider-items a:nth-child('+ activeIndex +')')[0].click();
        scrollNavToEl(activeIndex - 1);
    }
});
$navProductSlider.find('.info-slider-next').on('click', function () {
    let slideCount = $navProductSlider.find('.info-slider-items a').length - 1,
        activeIndex = $navProductSlider.find('.info-slider-items a.active').index();
    if(activeIndex < slideCount) {
        let tmpIndex = activeIndex + 2;
        $navProductSlider.find('.info-slider-items a:nth-child('+ tmpIndex +')')[0].click();
        scrollNavToEl(activeIndex + 1);
    }
});

function scrollNavToEl(index) {
    let allIndex = $navProductSlider.find('.info-slider-items a').length - 1,
        distance = (index > 1) ? index * 140 : 0;

    if(index === 0) {
        $navProductSlider.find('.info-slider-next').removeClass('disabled');
        $navProductSlider.find('.info-slider-prev').addClass('disabled');
    } else if(index > 0 && index < allIndex) {
        $navProductSlider.find('.info-slider-prev').removeClass('disabled');
        $navProductSlider.find('.info-slider-next').removeClass('disabled');
    } else if(index === allIndex) {
        $navProductSlider.find('.info-slider-prev').removeClass('disabled');
        $navProductSlider.find('.info-slider-next').addClass('disabled');
    }

    $navProductSlider.find('.info-slider-items').animate({
        scrollTop: distance
    }, 500);
}

if($('.info-slider-slider:not(.no-init)').length) {
    $('.info-slider-slider:not(.no-init)').owlCarousel({
        items: 1,
        loop: false,
        dots: false,
        margin: 10,
        URLhashListener: true,
        //autoplayHoverPause:true,
        startPosition: 'URLHash',
        onChanged: function (event) {
            var currentItem = event.item.index;
            if (currentItem !== null) {
                scrollNavToEl(currentItem);

                currentItem++;
                $('.info-slider-nav a').removeClass('active');
                $('.info-slider-nav a:nth-child(' + currentItem + ')').addClass('active');
            }
        },
        responsive: {
            0: {
                dots: true,
            },
            992: {
                dots: false,
            }
        }
    });
    $navProductSlider.find('.info-slider-prev, .info-slider-next').css('visibility', 'visible');
}

// $navProductSlider.find('.info-slider-items').mCustomScrollbar({
//     axis:"y"
// });


/**
 * Accordion
 */
let $accordionS = $('.accordion_toggle');
if($accordionS.length) {
    $(document).on('click', '.accordion_toggle h3, .accordion_toggle .style_h3, .accordion_toggle .tap_accordion', function () {
        if($('.filter_block').length){

        } else {
            $accordionS.find('.content, .content_area').not($(this).siblings('.content')).slideUp(200);
            $accordionS.find('h3, .tap_accordion').not($(this)).removeClass();
        }

        $(this).siblings('.content, .content_area').slideToggle(200);
        $(this).toggleClass('open');
    })
}


/**
 * Auto grow
 */
let $textarea = $('textarea.auto_grow');
if($textarea.length) {
    $textarea.on('keyup', function () {
        this.style.height = "10px";
        this.style.height = (this.scrollHeight)+ "px";
    })
}

//Add comment
let $comment = $('.add_comment');
if($comment.length) {
    let $commentInit = $comment.validate({
        highlight: function(element) {
            $(element).parent().addClass("error").removeClass("valid");
        },
        unhighlight: function(element) {
            $(element).parent().removeClass("error").addClass("valid");
        },
        submitHandler: function (form) {

            $(form).find('button').prop('disabled', true).addClass('button--preload-sending');

            let data = {
                product_id: $(form).find('input[name="product_id"]').val(),
                name: $(form).find('input[name="name"]').val(),
                email: $(form).find('input[name="email"]').val(),
                comment: $(form).find('textarea[name="comment"]').val(),
            };

            $.ajax({
                type: "POST",
                url: '/' + LANGUAGE + '/add_comment',
                data: data
            }).done(function (data) {
                let $wrap = $(form).parent();

                if(data.success) {
                    $wrap.find('.result-send')
                        .removeClass('error')
                        .addClass('success')
                        .html(data.success);
                }
                if(data.error) {
                    $wrap.find('.result-send')
                        .removeClass('success')
                        .addClass('error')
                        .html(data.error);
                }

                $(form).fadeOut(200, function () {
                    $wrap.find('.result-send').fadeIn(200);
                    $(form).find('button').prop('disabled', false).removeClass('button--preload-sending');
                    $comment.find('textarea').removeAttr('style');
                });
            });
        }
    });

    $('.wrap_right_bar .close-button, .overlay_page').on('click', function () {
        $commentInit.resetForm();
        $comment[0].reset();
        $comment.parent().find('.result-send').fadeOut(200, function () {
            $comment.fadeIn(200);
            $comment.find('textarea').removeAttr('style');
        })
    });
}



